export default __webpack_public_path__ + "static/media/right.b8041f8a.svg";